// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content067_wrapper___mgtL","top":"Content067_top__KDHHK","title":"Content067_title__UiSL0","description":"Content067_description__KUTqS"};